/**
 * Created by Rodrigo Quesada on 05/02/17.
 */
import {Model, ModelMixin} from '../../common/model.class';

export class ContinuingMedicalEducationInformation extends ModelMixin() implements Model<ContinuingMedicalEducationInformation> {

    TYPE = ContinuingMedicalEducationInformation;

    id: string;
    editableByRegularUser: boolean;

    constructor(jsonData: any = {}) {
        super();
        Object.assign(this, jsonData);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/licenses-certifications/cme/continuing-medical-education-information.model.ts